var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 25,
    fill: "#3141D0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 39,
    width: 21,
    height: 3,
    fill: "#3141D0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 85,
    width: 21,
    height: 3,
    fill: "#3141D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7159 87L34.9886 40.4545H40.7159L50.4432 78.3636H50.8977L60.8068 40.4545H67.1705L77.0795 78.3636H77.5341L87.2614 40.4545H92.9886L80.2614 87H74.4432L64.1705 49.9091H63.8068L53.5341 87H47.7159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebshop);
export default __webpack_public_path__ + "static/media/Webshop.7b0c97cf439dfaa3b8e66bfb4aaed9ef.svg";
export { ForwardRef as ReactComponent };